/* eslint-disable react/prop-types */
import React from 'react';
import { Row, Col, Button } from 'antd';
import Card from 'components/Containers/Card';
import Classes from 'modules/Teacher/widgets/Classes';
import Files from 'modules/Teacher/components/Files';
import Container from 'components/Containers/Container';
import { Link } from 'react-router-dom';
import withAuthenticator from 'HOCs/withAuthenticator';
import { logAnalyticsEvent } from 'helpers/AnalyticsHelper';

const Home = ({ loggedInUser, hostname }) => {
  React.useEffect(() => {
    logAnalyticsEvent('teacher-event', {
      teacherId: loggedInUser?.id,
      teacherEmail: loggedInUser.email,
    });
  }, []);

  if (hostname === 'heid') {
    return (
      <Container name='Trang chủ' parentName='LMS'>
        <Row gutter={16}>
          <Col span={24}>
            <Card title='Các lớp học đang quản lý' style={{ minHeight: 300 }}>
              <Classes />
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container name='Trang chủ' parentName='LMS'>
      <Row gutter={16}>
        <Col span={24} xl={18} lg={16} md={14} sm={12}>
          {!loggedInUser?.schoolTypeId && loggedInUser?.id !== 38880 && (
            <Card title='Hoạt động'>
              <React.Fragment>
                <h3 className='tw-text-red-500'>Tài khoản giáo viên chưa cập nhật thông tin chi tiết.</h3>
                <p>Vui lòng cập nhật thông tin trước khi sử dụng.</p>
                <Link to='/lms/profile'>
                  <Button type='primary'>Cập nhật thông tin</Button>
                </Link>
              </React.Fragment>
            </Card>
          )}

          <Card title='Tài liệu chuyên môn nghiệp vụ'>
            <Files />
          </Card>
        </Col>
        <Col span={24} xl={6} lg={8} md={10} sm={12}>
          <Card title='Các lớp học đang quản lý' style={{ minHeight: 300 }}>
            <Classes />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default withAuthenticator(Home);
